const parallax = {
    init() {
        const items = document.querySelectorAll('.js-parallax');

        if (! items.length) {
            return;
        }

        let ticking = false;

        function update() {
            ticking = false;

            const viewportCenter = window.innerHeight / 2;

            items.forEach(function (item) {
                const speed = parseFloat(item.dataset.parallaxSpeed) || 0.1;
                const rect = item.getBoundingClientRect();
                const itemCenter = rect.top + rect.height / 2;
                const offset = (viewportCenter - itemCenter) * speed;

                item.style.transform = `translate3d(0, ${offset}px, 0)`;
            });
        }

        function requestUpdate() {
            if (! ticking) {
                ticking = true;
                window.requestAnimationFrame(update);
            }
        }

        update();
        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate);
    }
}

export default parallax
